// extracted by mini-css-extract-plugin
module.exports = {"eco-blog-items-card":"BlogCard_eco-blog-items-card__DIST6"};